import { colors } from "constants/colors";
import { CSSProperties } from "react";
import { Column } from "react-table-8.10.7";

export const getCommonPinningStyles = <T>(
  column: Column<T>,
  color: string = colors.surface["DEFAULT"],
  defaultColor: string = "transparent",
  zIndex: number = 1
): CSSProperties => {
  const isPinned = column.getIsPinned();

  return {
    backgroundColor: isPinned ? color : defaultColor,
    left: isPinned === "left" ? `${column.getStart("left")}px` : undefined,
    right: isPinned === "right" ? `${column.getAfter("right")}px` : undefined,
    position: isPinned ? "sticky" : "relative",
    zIndex: isPinned ? zIndex : 0,
  };
};
